var Color = require('color');

Color.prototype.toString = function () {
  return this.hexString();
};

function blend(color, blendColor, percentage) {
  var other = new Color(blendColor);
  return color.mix(other, 1 - percentage).hexString();
}

function shade(color, percentage) {
  return blend(Color(color), 'black', percentage);
}

function tint(color, percentage) {
  return blend(Color(color), 'white', percentage);
}

module.exports = {
  primary: '#F09103',

  get primaryLight90() {
    return this._primaryLight90 || tint(Color(this.primary), 0.9);
  },
  set primaryLight90(color) {this._primaryLight90 = color;},

  get primaryLight85() {
    return this._primaryLight85 || tint(Color(this.primary), 0.85);
  },
  set primaryLight85(color) {this._primaryLight85 = color;},

  get primaryLight40() {
    return this._primaryLight40 || tint(Color(this.primary), 0.4);
  },
  set primaryLight40(color) {this._primaryLight40 = color;},

  get primaryLight20() {
    return this._primaryLight20 || tint(Color(this.primary), 0.2);
  },
  set primaryLight20(color) {this._primaryLight20 = color;},
  secondary: '#165297',

  get secondaryLight90() {
    return this._secondaryLight90 || tint(Color(this.secondary), 0.9);
  },
  set secondaryLight90(color) {this._secondaryLight90 = color;},

  get secondaryLight85() {
    return this._secondaryLight85 || tint(Color(this.secondary), 0.85);
  },
  set secondaryLight85(color) {this._secondaryLight85 = color;},

  get secondaryLight40() {
    return this._secondaryLight40 || tint(Color(this.secondary), 0.4);
  },
  set secondaryLight40(color) {this._secondaryLight40 = color;},

  get secondaryLight20() {
    return this._secondaryLight20 || tint(Color(this.secondary), 0.2);
  },
  set secondaryLight20(color) {this._secondaryLight20 = color;},

  get secondaryDark40() {
    return this._secondaryDark40 || shade(Color(this.secondary), 0.4);
  },
  set secondaryDark40(color) {this._secondaryDark40 = color;},
  base: '#7B8A96',

  get baseLight90() {
    return this._baseLight90 || tint(Color(this.base), 0.9);
  },
  set baseLight90(color) {this._baseLight90 = color;},

  get baseLight80() {
    return this._baseLight80 || tint(Color(this.base), 0.8);
  },
  set baseLight80(color) {this._baseLight80 = color;},

  get baseLight40() {
    return this._baseLight40 || tint(Color(this.base), 0.4);
  },
  set baseLight40(color) {this._baseLight40 = color;},

  get baseLight20() {
    return this._baseLight20 || tint(Color(this.base), 0.2);
  },
  set baseLight20(color) {this._baseLight20 = color;},

  get baseDark40() {
    return this._baseDark40 || shade(Color(this.base), 0.4);
  },
  set baseDark40(color) {this._baseDark40 = color;},

  get baseDark80() {
    return this._baseDark80 || shade(Color(this.base), 0.8);
  },
  set baseDark80(color) {this._baseDark80 = color;},
  success: '#42C242',

  get successLight60() {
    return this._successLight60 || tint(Color(this.success), 0.6);
  },
  set successLight60(color) {this._successLight60 = color;},
  danger: '#FF4942',

  get dangerLight60() {
    return this._dangerLight60 || tint(Color(this.danger), 0.6);
  },
  set dangerLight60(color) {this._dangerLight60 = color;},
  warning: '#FFDA47',

  get warningLight60() {
    return this._warningLight60 || tint(Color(this.warning), 0.6);
  },
  set warningLight60(color) {this._warningLight60 = color;},
};
